import { render, staticRenderFns } from "./addwords.vue?vue&type=template&id=6aacdbde&scoped=true&"
import script from "./addwords.vue?vue&type=script&lang=js&"
export * from "./addwords.vue?vue&type=script&lang=js&"
import style0 from "./addwords.vue?vue&type=style&index=0&id=6aacdbde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aacdbde",
  null
  
)

export default component.exports